import { render, staticRenderFns } from "./modal-velocity.vue?vue&type=template&id=18f909be&"
import script from "./modal-velocity.vue?vue&type=script&lang=js&"
export * from "./modal-velocity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports